import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const create = ({ commit }, values) => {
  commit(types.PRODUCTPRICETYPE_CREATE_SET_ERROR, '')
  commit(types.PRODUCTPRICETYPE_CREATE_TOGGLE_LOADING)

  return fetch('/product_price_types', { method: 'POST', body: JSON.stringify(values) })
    .then((response) => {
      commit(types.PRODUCTPRICETYPE_CREATE_TOGGLE_LOADING)

      return response.json()
    })
    .then((data) => {
      commit(types.PRODUCTPRICETYPE_CREATE_SET_CREATED, data)

      return data
    })
    .catch((e) => {
      commit(types.PRODUCTPRICETYPE_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.PRODUCTPRICETYPE_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.PRODUCTPRICETYPE_CREATE_SET_ERROR, e.errors._error)
        return
      }

      commit(types.PRODUCTPRICETYPE_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.PRODUCTPRICETYPE_CREATE_RESET)
}



// WEBPACK FOOTER //
// ./src/store/modules/product_price_type/create/actions.js